module.exports = __webpack_public_path__ + "img/detail_banner_jdkq.63364d6b.png";